class FiltersResume {
	constructor(manager) {
		this._init(manager)
	}
	_init(manager) {
		this.el = document.querySelector('[data-filters-resume]')
		this.manager = manager
		if(!this.el) {
			return
		}
		this.setVariables()
		this.setEventListeners()
		this.updateList()
	}
	setVariables() {
		this.priceKeys = ['from', 'to']
		this.ignoredKeys = ['sort', 'search', 'page', 'view']
		this.elSidebar = document.querySelector('[data-sidebar]')
		this.elList    = this.el.querySelector('[data-filters-list]')
		this.elClear   = this.el.querySelector('[data-filters-clear]')
		this.elAction  = this.el.querySelector("[data-filters-action]")
		this.elAmount = this.el.querySelector('[data-filters-amount]')
		this.timeout = null
		this.promise = null
	}
	setEventListeners() {
		// window.addEventListener("popstate", () => this.updateList())
		this.elClear.addEventListener("click", (e) => this.clearFilters(e))
		this.el.addEventListener("toggle", () => this.onActionClick())
	}
	clearFilters(e) {
		e.preventDefault()
		const mParams = this.manager.params
		let newParams = new URLSearchParams()
		if(mParams.has('search')) {
			const param = mParams.get('search')
			newParams.append('search', param)
		}

		this.manager.updateParams(newParams)

		this.el.open = false
		// this.dispatchEvent()
	}
	// dispatchEvent() {
	// 	const popStateEvent = new PopStateEvent('popstate', { state: null })
	// 	window.dispatchEvent(popStateEvent)
	// }
	onActionClick() {
		if(this.el.open) {
			this.elSidebar.classList.add("sidebar-is-active")
		} else {
			this.elSidebar.classList.remove("sidebar-is-active")
		}
	}
	updateList() {
		const mParams = this.manager.params
		this.getList().forEach(el => {
			el.parentNode.removeChild(el)
		})
		let amount = 0
		let priceValues = [,]

		if (mParams && this.priceKeys) {
			mParams.forEach((value, key) => {
				if(!this.priceKeys.includes(key) && !this.ignoredKeys.includes(key)) {
					this.createNewElement(value)
					amount++
				} else {
					priceValues[this.priceKeys.indexOf(key)] = value
				}
			})

			if(priceValues[0]) {
				this.createPriceElement(priceValues[0], priceValues[1])
				amount++
			}
			this.elAmount.innerHTML = amount != 0 ? amount : ""
		}
	}
	createNewElement(v, id = v) {
		const el = document.createElement("li")
		if(v == id) {
			el.innerHTML = v.split('-')[0]
		} else {
			el.innerHTML = v
		}
		el.classList.add("filters-resume__element")
		el.setAttribute("data-filter-id", id)
		el.filter = new Filter(el, this.manager)
		this.elList.appendChild(el)
	}
	createPriceElement(from, to) {
		this.createNewElement( "€" + from +" - €" + to, "price")
	}
	getList() {
		if (!this.elList) {
			return  []
		}
		return this.elList.querySelectorAll("[data-filter-id]")
	}
}

class Filter {
	constructor (el, manager) {
		this._init(el, manager)
	}
	_init(el, manager) {
		this.el = el
		this.manager = manager
		if(!this.el) {
			return
		}
		this.id = this.el.getAttribute("data-filter-id")
		this.el.addEventListener("click", () => this.onClick())
	}
	onClick() {
		this.updateParams()
		// this.updateURL(params)
		// this.dispatchEvent()
	}
	updateParams() {
		let mParams = this.manager.params
		if(this.id !== "price") {
			const values = Array.from(mParams.values())
			const newParams = Array.from(mParams)
			const index = values.indexOf(this.id)
			newParams.splice(index, 1)
			mParams = new URLSearchParams(newParams)
		}

		["from", "to"].forEach(key => {
			mParams.delete(key)
		})

		this.manager.updateParams(mParams)
	}
	// updateURL(newParams) {
    //     newParams.delete('page')
    //     newParams.delete('view')
	// 	newParams.sort()
	// 	window.history.replaceState({}, '', `${location.pathname}?${newParams}`)
	// }
	// dispatchEvent() {
	// 	this.manager.dispatchEvent()
	// }
}

export default FiltersResume